import { Signal } from "@lit-labs/signals";
import type { IExploreCreatorsState, IExploreCreatorsData } from "./types";

export class ExploreCreatorsState implements IExploreCreatorsState {
  readonly creators = new Signal.State<IExploreCreatorsData | null>(null);
  readonly loading = new Signal.State<boolean>(false);
  readonly error = new Signal.State<string | null>(null);
}
